module.exports = __webpack_public_path__ + "img/BatteringRam64_ua.ea272ca4.webp";